import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { NotificationService } from '../notification.service';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { QueryParamService } from '../query-param-service.service';

@Component({
  selector: 'app-rentals',
  templateUrl: './rentals.component.html',
  styleUrls: ['./rentals.component.scss'],
})
export class RentalsComponent implements OnInit {
  public vehicleRequests: any[];
  public recordPerPage: number = 10;
  public page: number = 1;
  public totalRecords: number;
  private searchSubject = new Subject<string>();
  public queryParams: any;

  constructor(
    private api: CommonService,
    private notification: NotificationService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private queryParamService: QueryParamService
  ) {}

  ngOnInit(): void {
    this.searchSubject.pipe(debounceTime(500)).subscribe((value) => {
      this.queryParamService.setQueryParams({ search: value || null });
    });

    this.route.queryParams.pipe(distinctUntilChanged()).subscribe((params) => {
      this.page = 1;
      this.fetchRentalVehicleRequests(params);
      this.queryParams = params;
    });
  }

  onFilterSelect(event: Event) {
    const { name, value } = event.target as HTMLInputElement;
    if (name === 'search') {
      this.searchSubject.next(value);
      return;
    }
    this.queryParamService.setQueryParams({
      [name]: ['', 'All'].includes(value) ? null : value,
    });
  }

  fetchRentalVehicleRequests(params?: any) {
    this.spinner.show();
    const queryParams = {
      page: this.page,
      limit: this.recordPerPage,
      ...params
    }

    this.api.getRentalVehicleRequests(queryParams).subscribe({
      next: ({ data }) => {
        this.vehicleRequests = data.requests;
        this.totalRecords = data.count;
        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        if (error.error?.statusCode < 500) {
          this.notification.showError(error.error.message, '');
        } else {
          this.notification.showError(
            'something went wrong while fetching rental requests.',
            ''
          );
        }
      },
    });
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.fetchRentalVehicleRequests(this.queryParams);
  }
}
